/** Admin demo fixtures — shapes aligned with manage/app overview. */

export const DEMO_PROFILE = {
  id: "demo-admin",
  full_name: "Владимир Байков",
  photo_url: null,
  email: "demo@baysport.local",
};

export const DEMO_TENANT_DEFAULTS = {
  id: "demo-tenant",
  name: "Тигр",
  subdomain: "demo",
  portal_accent_color: "#ea580c",
  portal_cover_url: null,
  portal_font_family: "manrope",
  portal_theme_mode: "dark",
};

export const DEMO_ENTITLEMENTS = {
  plan: { code: "business", name: "Максимальный" },
  features: {
    chat: true,
    club_life: true,
    member_social: true,
    competitions: true,
    polls: true,
    polls_advanced: true,
    branding: true,
    branding_lite: true,
    splash_branding: true,
  },
};

function hoursFromNow(h) {
  return new Date(Date.now() + h * 3600_000).toISOString();
}

function hoursAgo(h) {
  return new Date(Date.now() - h * 3600_000).toISOString();
}

export const DEMO_ADMIN_SESSIONS = [
  {
    id: "as1",
    start_datetime: hoursAgo(20),
    end_datetime: hoursAgo(18.5),
    status: "scheduled",
    group: { id: "g1", name: "Младшая группа" },
    trainer: { user: { id: "t1", full_name: "Максим Орлов" } },
    venue: { name: "Основной зал" },
    present_count: 0,
    expected_count: 3,
    unfinished: true,
  },
  {
    id: "as2",
    start_datetime: hoursFromNow(2),
    end_datetime: hoursFromNow(3.5),
    status: "scheduled",
    group: { id: "g2", name: "Общая группа" },
    trainer: { user: { id: "demo-admin", full_name: "Владимир Байков" } },
    venue: { name: "Основной зал" },
    present_count: 0,
    expected_count: 12,
    coming_count: 7,
  },
  {
    id: "as3",
    start_datetime: hoursFromNow(26),
    end_datetime: hoursFromNow(27.5),
    status: "scheduled",
    group: { id: "g3", name: "Спарринг" },
    trainer: { user: { id: "t1", full_name: "Максим Орлов" } },
    venue: { name: "Зал 2" },
    present_count: 0,
    expected_count: 8,
    coming_count: 4,
  },
];

export const DEMO_ATTENTION = [
  {
    id: "att1",
    title: "Перекличка не завершена",
    text: "Занятие «Младшая группа» · прошло — отмечено 0/3",
    action: "Журнал",
  },
  {
    id: "att2",
    title: "Должники",
    text: "2 клиента с просроченной оплатой абонемента",
    action: "Клиенты",
  },
  {
    id: "att3",
    title: "Заявки в клуб",
    text: "1 новая заявка на регистрацию ожидает решения",
    action: "Заявки",
  },
];

export const DEMO_CLIENTS = [
  {
    id: "c1",
    full_name: "Артём Иванов",
    group: "Общая группа",
    membership: "8 / 12",
    status: "active",
  },
  {
    id: "c2",
    full_name: "Мария Смирнова",
    group: "Младшая группа",
    membership: "Долг",
    status: "debt",
  },
  {
    id: "c3",
    full_name: "Илья Козлов",
    group: "Спарринг",
    membership: "∞",
    status: "active",
  },
];

export const DEMO_KPI = {
  clientsExpected: 7,
  sessionsToday: 1,
  revenueToday: 0,
};

/** Kept for any leftover client imports */
export const DEMO_DASHBOARD = {};
export const DEMO_SESSIONS = DEMO_ADMIN_SESSIONS;
export const DEMO_POLL = null;
export const DEMO_SEED_POSTS = [];
